<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/heXJir/tc-custom/9781504034913.jpg?1705548156404" alt="This image is the cover for the book Light Years, The Cazalet Chronicles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Light Years, The Cazalet Chronicles
      </h1>
      <p class="bookDescription body article font2">
        <b>This “dazzling” novel follows a family of English aristocrats as their country teeters on the brink of World War II (Penelope Fitzgerald).</b><br/><br/>  As war clouds gather on the distant horizon, Hugh, Edward, and Rupert Cazalet, along with their wives, children, and loyal servants, prepare to leave London for their annual pilgrimage to the family’s Sussex estate. There, they will join their parents, William and Kitty, and sister, Rachel, at Home Place, the sprawling retreat where the three brothers hope to spend an idyllic summer of years gone by. But the First World War has left indelible scars.<br/>  <br/> Hugh, the eldest of his siblings, was wounded in France and is haunted both by recurring nightmares of battle and the prospect of another war. Edward adores his wife, Villy, a former dancer searching for meaning in life, yet he’s incapable of remaining faithful to her. Rupert desires only to fulfill his potential as a painter, but finds that love and art cannot coexist. And devoted daughter Rachel discovers the joys—and limitations—of intimacy with another woman.<br/>  <br/> A candid portrait of British life in the late 1930s and a sweeping depiction of a world on the brink of war, <i>The Light Years </i>is a must-read for fans of <i>Downton Abbey.</i> Three generations of the Cazalet family come to unforgettable dramatic life in this saga about England during the last century—and the long-held values and cherished traditions that would soon disappear forever.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elizabeth Jane Howard
      </h2>
      
      <p class="authorDescription body article">Elizabeth Jane Howard (1923&ndash;2014) is the author of fourteen highly acclaimed novels. Her Cazalet Chronicles&mdash;<I>The Light Years</I>, <I>Marking Time</I>, <I>Confusion</I>, <I>Casting Off</I>, and <I>All Change</I>&mdash;are modern classics and have been adapted for BBC television and BBC Radio 4. Her autobiography, <I>Slipstream</I>, was published in 2002. In that same year she was named a Commander of the Most Excellent Order of the British Empire.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6f7da208